import styled from "styled-components";

export const SelectContainer = styled.div`
  svg {
    color: #1e1355;
  }
`;
